import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-session-expired-page',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  template: `
    <section class="session-page">
      <div class="session-panel">
        <mat-icon>lock_clock</mat-icon>
        <h1>Tu sesión necesita volver a iniciarse</h1>
        <p>Para continuar, iniciá sesión nuevamente.</p>
        <button mat-flat-button color="primary" type="button" (click)="login()">
          Iniciar sesión
        </button>
      </div>
    </section>
  `,
  styles: [`
    :host {
      display: block;
    }

    .session-page {
      align-items: center;
      background: #eaf8ff;
      display: flex;
      min-height: calc(100vh - 80px);
      justify-content: center;
      padding: 24px;
    }

    .session-panel {
      align-items: center;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      color: #003f70;
      display: flex;
      flex-direction: column;
      max-width: 420px;
      padding: 32px;
      text-align: center;
      width: 100%;
    }

    mat-icon {
      color: #5a8fcb;
      font-size: 44px;
      height: 44px;
      margin-bottom: 12px;
      width: 44px;
    }

    h1 {
      font-size: 1.35rem;
      margin: 0 0 8px;
    }

    p {
      color: #66717b;
      margin: 0 0 22px;
    }
  `],
})
export class SessionExpiredPageComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
  ) {}

  login(): void {
    const redirect = this.route.snapshot.queryParamMap.get('redirect') || '/';
    this.authService.login(window.location.origin + redirect);
  }
}
